import React from 'react';
import { PRIVACY_URL, STORE_URL, SUPPORT_EMAIL, SUPPORT_MAILTO, TERMS_URL } from '../../data/site';
const links = [{
  label: 'Store',
  href: STORE_URL
}, {
  label: 'Terms',
  href: TERMS_URL
}, {
  label: 'Privacy',
  href: PRIVACY_URL
}];
export function Footer() {
  return <footer className="border-t-4 border-gold bg-mint pb-28 pt-12 text-ink md:pb-12" data-id="element-169" data-mp="5nchdis7j9ii">
      <div className="mx-auto max-w-page px-5 lg:px-8" data-id="element-170" data-mp="5pf86516p6oa">
        <div className="flex flex-col items-center gap-6 text-center md:flex-row md:justify-between md:text-left" data-id="element-171" data-mp="orfzg17yjsh">
          <div data-id="element-172" data-mp="3s1ce7zvg22bh">
            <p className="font-display text-[26px] font-bold uppercase leading-none" data-id="element-173" data-mp="3s0u88bizc9qd">
              Flag Football <span className="text-gold-dark" data-id="element-174" data-mp="3n17snvfoihee">Class Ready</span>
            </p>
            <p className="mt-2 text-base text-body" data-id="element-175" data-mp="3j3tlsafh0lpk">
              Support:{' '}
              <a href={SUPPORT_MAILTO} className="font-bold text-ink underline underline-offset-4 hover:text-gold-dark" data-id="element-176" data-mp="3e1kudii8xrpk">
                {SUPPORT_EMAIL}
              </a>
            </p>
          </div>
          <nav aria-label="Footer" data-id="element-177" data-mp="2kbjsf4joxzeg">
            <ul className="flex flex-wrap justify-center gap-x-6 gap-y-2" data-id="element-178" data-mp="2kba3zleao0av">
              {links.map(link => <li key={link.label} data-id="element-179" data-mp="2bconrwwaoxd9">
                  <a href={link.href} className="inline-flex min-h-[44px] items-center text-base text-body hover:text-ink" data-id="element-180" data-mp="2bdpwhupu97rt">
                    {link.label}
                  </a>
                </li>)}
            </ul>
          </nav>
        </div>
        <p className="mt-8 border-t border-line pt-6 text-center text-sm text-body md:text-left" data-id="element-181" data-mp="382fedl1gu0ds">
          © 2026 Flag Football Class Ready. Prices in USD. Independent school resource; not affiliated with the NFL or any governing body.
        </p>
      </div>
    </footer>;
}